import {bookingFormActionTypes} from "./BookingFormActionTypes";

export const initialiseForm = () => {
    return (dispatch, getState) => {
        dispatch(
            forwardAction(bookingFormActionTypes.INITIALISE_FORM, {
                prototypes: getState().module['VISITORS'].common.prototypes
            })
        );
    };
}

export const resetForm = () => {
    return (dispatch, getState) => {
        let params = {
            prototypes: getState().module['VISITORS'].common.prototypes,
            previousHosts: getState().module['VISITORS'].bookingForm.hosts
        };

        dispatch(
            forwardAction(bookingFormActionTypes.RESET_FORM, params)
        );
    };
}

export const setDefaultCollapsedState = () => ({
    type: bookingFormActionTypes.SET_DEFAULT_COLLAPSED_STATE
});

export const setBookingType = (value) => ({
    type: bookingFormActionTypes.SET_BOOKING_TYPE,
    value,
});

export const seteditEventRecurrenceType = (value) => ({
    type: bookingFormActionTypes.SET_RECURRENCE_EDIT_TYPE,
    value,
});


export const setVisitsAreLoading = (value) => ({
    type: bookingFormActionTypes.SET_IS_LOADING,
    value
});

export const setIsSaving = (value) => ({
    type: bookingFormActionTypes.SET_IS_SAVING,
    value
})

export const setImportModalOpen = (value) => ({
    type: bookingFormActionTypes.SET_IMPORT_MODAL_OPEN,
    value
})

export const setConfirmationModalOpen = (value) => ({
    type: bookingFormActionTypes.SET_CONFIRMATION_MODAL_OPEN,
    value
})

export const setWillPrintPassAfterSubmit = (value) => ({
    type: bookingFormActionTypes.SET_WILL_PRINT_PASS_AFTER_SUBMIT,
    value
});

export const populateData = (data) => {
    return (dispatch, getState) => {
        const {prototypes} = getState().module['VISITORS'].common;
        dispatch(populateData2(data, prototypes))
    }
}
export const populateData2 = (data, prototypes) => ({
    type: bookingFormActionTypes.POPULATE_DATA,
    payload: {
        data: data,
        prototypes: prototypes,
    },
});

export const setErrors = (errors) => ({
    type: bookingFormActionTypes.SET_ERRORS,
    value: errors
})


export const updateHost = (name, value, index) => ({
    type: bookingFormActionTypes.UPDATE_HOST,
    payload: {
        name: name,
        value: value,
        index: parseInt(index)
    }
});

export const updateVisit = (name, value, index) => ({
    type: bookingFormActionTypes.UPDATE_VISIT,
    payload: {
        name: name,
        value: value,
        index: parseInt(index)
    }
});

export const updateAllVisits = (name, value) => ({
    type: bookingFormActionTypes.UPDATE_ALL_VISITS,
    payload: {
        name: name,
        value: value,
    }
});

export const updateAllVisitsExceptLast = (name, value) => ({
    type: bookingFormActionTypes.UPDATE_ALL_VISITS_EXCEPT_LAST,
    payload: {
        name: name,
        value: value,
    }
});

export const updateVisitor = (name, value, index) => ({
    type: bookingFormActionTypes.UPDATE_VISITOR,
    payload: {
        name: name,
        value: value,
        index: parseInt(index)
    }
});

/**
 * @param host
 */
export const addHost = (host) => {
    return (dispatch, getState) => {
        dispatch(forwardAction(
            bookingFormActionTypes.ADD_HOST,
            {
                host: (host) ? host : {},
                prototypes: getState().module['VISITORS'].common.prototypes
            }
        ));
    }
}

/**
 * @param visit
 * @param visitor
 * @param keepExpanded    If true - do nogt collapse any newly created visits/visitors
 */
export const addVisitAndVisitor = (visit, visitor, keepExpanded) => {
    return (dispatch, getState) => {
        dispatch(forwardAction(
            bookingFormActionTypes.ADD_VISIT_AND_VISITOR,
            {
                visit: (visit) ? visit : {},
                visitor: (visitor) ? visitor : {},
                prototypes: getState().module['VISITORS'].common.prototypes,
                keepExpanded: keepExpanded ?? false
            }
        ));
    }
}

/**
 * @param visit
 */
export const addVisit = (visit) => {
    return (dispatch, getState) => {
        dispatch(forwardAction(
            bookingFormActionTypes.ADD_VISIT,
            {   visit: (visit) ? visit : {},
                prototypes: getState().module['VISITORS'].common.prototypes
            }
        ))
    }
}

/**
 * This seems dumb to me, but it exists merely to forward actions that have previously
 * 'become aware' of the state of other reducers within the preceeding action creator.
 * As recommended here by Dan Abramov: https://stackoverflow.com/questions/35667249/accessing-redux-state-in-an-action-creator/35674575#35674575
 * I've got no idea if there's a better way to do this yet.
 * @param type
 * @param payload
 * @returns {{payload, type}}
 */
export const forwardAction = (type, payload) => ({
    type: type,
    payload: payload
})

/**
 * @param visitor
 */
export const addVisitor = (visitor) => {
    return (dispatch, getState) => {
        dispatch(forwardAction(
            bookingFormActionTypes.ADD_VISITOR,
            {   visitor: (visitor) ? visitor : {},
                prototypes: getState().module['VISITORS'].common.prototypes
            }
        ))
    }
}

export const deleteHost = (index) => {
    return (dispatch, getState) => {
        dispatch(
            forwardAction(bookingFormActionTypes.DELETE_HOST, {
                prototypes: getState().module['VISITORS'].common.prototypes,
                index: parseInt(index)
            })
        );
    };
}

export const deleteVisitAndVisitor = (index) => {
    return (dispatch, getState) => {
        dispatch(
            forwardAction(bookingFormActionTypes.DELETE_VISIT_AND_VISITOR, {
                prototypes: getState().module['VISITORS'].common.prototypes,
                index: parseInt(index)
            })
        );
    };
}

export const deleteVisit = (index) => ({
    type: bookingFormActionTypes.DELETE_VISIT,
    index: parseInt(index)
})

export const deleteVisitor = (index) => ({
    type: bookingFormActionTypes.DELETE_VISITOR,
    index: parseInt(index)
})

export const deleteAllVisitsExceptFirst = () => ({
    type: bookingFormActionTypes.DELETE_ALL_VISITS_EXCEPT_FIRST
})

export const deleteEmptyVisitsAndVisitors = (keepFirstEmpty = true, useLowestIndex = false, emptySlotAtEnd = false) => {
    return (dispatch, getState) => {
        dispatch(forwardAction(
            bookingFormActionTypes.DELETE_EMPTY_VISITS_AND_VISITORS,
            {
                keepFirstEmpty: keepFirstEmpty,
                useLowestIndex: useLowestIndex,
                emptySlotAtEnd: emptySlotAtEnd,
                prototypes: getState().module['VISITORS'].common.prototypes
            }
        ))
    }
}
